import { z } from 'zod';
import type { TFunction } from 'i18next';

export function createLoginSchema(t: TFunction) {
  return z.object({
    email: z
      .string()
      .min(1, t('validation.email_required'))
      .email(t('validation.email_invalid')),
    password: z
      .string()
      .min(1, t('validation.password_required')),
  });
}

export type LoginFormValues = z.infer<ReturnType<typeof createLoginSchema>>;
